import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Fab, withStyles } from "@material-ui/core";
import ImprimirApp from "app/Core/Components/Imprimir/ImprimirApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import React from "react";
import { MdAdd } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/ConteudoActions";

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class ConteudoList extends XAPPComponent {

    state = {
        selected: []
    };

    componentDidMount() {
        const { listFilter, xappRouteParams } = this.props;
        listFilter("SELECIONAR", xappRouteParams);
    }

    componentDidUpdate(prevProps) {
        if (this.props.Conteudo.error) {
            this.props.showMessage({
                message: this.props.Conteudo.error,
                variant: "error"
            });
            this.props.Conteudo.error = null;
        }

        if (this.props.getAcoes() === null || !_.isEqual(this.props.Conteudo.data, prevProps.Conteudo.data)) {
            this.props.setAcoes(
                <React.Fragment>
                    {!_.isNull(this.props.Conteudo.data) &&
                        <ImprimirApp
                            data={this.props.Conteudo.data}
                            key="btnImprimir"
                            id="EmpresaFinanceiroCaixa"
                            label="Conteudo"
                            column={this.getColumns()}
                            className="mr-12"
                        />
                    }
                    <Fab
                        id={"fab-add-conteudo"}
                        color="primary"
                        aria-label="add"
                        onClick={() => { this.props.openDialog({}); }}
                        className="mt-16"
                    >
                        <MdAdd className="text-24 text-white" />
                    </Fab>
                </React.Fragment>
            );
        }
    }

    getColumns = () => {
        return [
            {
                Header: "Código",
                accessor: "idconteudo",
                width: 300,
            },
            {
                Header: "Titulo",
                accessor: "titulo"
            },
            {
                Header: "Tipo",
                accessor: "tipodescricao"
            },
            {
                Header: "Grupo",
                accessor: "grupodescricao"
            },
            {
                Header: "Categoria",
                accessor: "categoriadescricao"
            }
        ];
    };

    render() {
        const { Conteudo, classes, xappRouteParams, get } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "-striped -highlight border-0")}
                    getTrProps={(state, rowInfo) => {
                        return {
                            className: "cursor-pointer",
                            onClick: () => {
                                if (rowInfo) {
                                    get("SELECIONAR", xappRouteParams, rowInfo.original.idconteudo);
                                }
                            }
                        };
                    }}
                    data={Conteudo.data ? Conteudo.data : []}
                    columns={this.getColumns()}
                    defaultPageSize={10}
                    noDataText="Não existem registros cadastrados!"
                />
            </FuseAnimate>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
        get: Actions.get,
        openDialog: Actions.openDialog,
    }, dispatch);
}

function mapStateToProps({ Conteudo }) {
    return {
        Conteudo: Conteudo,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ConteudoList)));
